export default __webpack_public_path__ + "eec3ca9ae13f78244be9cc82cd42846c.jpg";